export const ClimateModes = ["HEATING", "COOLING"]
